<template>
    <div class="fe-question-wrap">
        <div class="after_tit_area">
            <div class="tit_bx">
                <h2 class="tit">
                    <span class="txt">{{ question.question }}</span>
                </h2>
            </div>
            <span class="sub_txt" v-show="questionInfoMessage" v-html="questionInfoMessage"></span>
        </div>

        <ul class="apply_lst">
            <li class="lst_img">
                <div class="image_area" v-if="question.image" @click="onClickPreviewImage(question.image.index)">
                    <img :src="question.image.url" alt="">
                </div>
            </li>
            <EnrolmentResponseProgram v-for="program in question.programs" :key="program.programNumber" :program="program" :questionNo="question.questionNo"></EnrolmentResponseProgram>
        </ul>
    </div>
</template>

<script>
import {SURVEY_ANSWER_STATE_TYPE} from '@/common/consts/response.js';

import EnrolmentResponseProgram from "@/iamteacherpc/components/response/EnrolmentResponseProgram.vue";

import {IS_AFTER_ENROLMENT_PERIOD} from '@/common/store/modules/enrolment/response.js';
import {createNamespacedHelpers} from "vuex";
import {ENROLMENT_RESPONSE_NAMESPACE} from "@/common/store";
import {toResponseViewFormat} from '@common/utils/date';

const {mapState, mapGetters} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: "EnrolmentResponseQuestion",
    components: {EnrolmentResponseProgram},
    data() {
        return {};
    },
        props: {
            question: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapState({
                answerStateType: state => state.survey.answerStateType,
                endDate: state => state.survey.endDate,
                drawDateTime: state => state.survey.draw?.drawDateTime,
                actualDrawDateTime: state => state.survey.draw?.actualDrawDateTime,
                isPreview: state => state.options.isPreview,
            }),

            ...mapGetters({
                isEndEnrolment: IS_AFTER_ENROLMENT_PERIOD
            }),

            isWebView() {
                return this.$route.query.hasOwnProperty('isMasking');
            },

            questionInfoMessage() {
                if (this.isEndEnrolment) {
                    const text = [this.$t('EnrolmentResponseQuestion_cantEditEndedEnrolment')];

                    if (this.actualDrawDateTime) {
                        text.push(this.$t('EnrolmentResponseQuestion_drawComplete', {date: toResponseViewFormat(this.actualDrawDateTime)}));
                    } else if (this.drawDateTime) {
                        text.push(this.$t('EnrolmentResponseQuestion_drawInProgress', {date: toResponseViewFormat(this.drawDateTime)}));
                    }

                    return text.join('<br>');
                }
                if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                    return this.$t('EnrolmentResponseQuestion_pleaseSelectApply');
                }
                if (this.question.maxChoice !== 0) {
                    return this.$t('EnrolmentResponseQuestion_canApplyMaxProgram', {max: this.question.maxChoice});
                }
                return this.$t('EnrolmentResponseQuestion_canApplyNoLimit');
            },
        },

        methods: {
            onClickPreviewImage(orderNo) {
                this.$eventBus.$emit('clickPreviewImage', {index: orderNo});
            },

        },
    }
</script>

<style scoped>

</style>
